import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";

import { NavBarComponent } from "./admin-panel/nav-bar/nav-bar.component";
import { SideNavComponent } from "./admin-panel/side-nav/side-nav.component";
import { FooterComponent } from "./admin-panel/footer/footer.component";
import { RouterModule } from "@angular/router";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { BreadcrumbsModule } from "ng6-breadcrumbs";
import { Ng2SearchPipeModule } from "ng2-search-filter";
import { FormsModule } from "@angular/forms";
import { MenuItemComponent } from "./admin-panel/side-nav/menu-item/menu-item.component";
import { AdminPanelComponent } from "./admin-panel/admin-panel.component";
import { ConfirmationDialogComponent } from "@app/shared/components/confirmation-dialog/confirmation-dialog.component";
import { SharedModule } from "@app/shared/shared.module";

@NgModule({
  declarations: [
    AdminPanelComponent,
    NavBarComponent,
    SideNavComponent,
    FooterComponent,
    MenuItemComponent,
    ConfirmationDialogComponent,
  ],
  imports: [
    CommonModule,
    RouterModule,
    BrowserAnimationsModule,
    BreadcrumbsModule,
    Ng2SearchPipeModule,
    FormsModule,
    SharedModule,
  ],
  entryComponents: [ConfirmationDialogComponent, FooterComponent],
  exports: [ConfirmationDialogComponent, FooterComponent],
})
export class LayoutModule {}
